<template>
  <div class="help-tooltip">
    <el-tooltip
      placement="bottom-end"
      :visible-arrow="false"
      popper-class="atooltip"
    >
      <div class="entry">
        <div class="tooltip-name">帮助说明</div>
        <img class="img-help" src="@/assets/images/icon_help.png" />
      </div>
      <div slot="content" id="tips-wrap">
        <div class="content-wrap">
          <div class="title">数据说明</div>
          <slot name="regular">
            <pre class="detail-des">
作品下载总次数：资源作品被玩家下载的累计次数
作品浏览总次数：资源作品详情页被玩家查看的累计次数
作品解锁总数：该作品被购买解锁进入到已购买列表的人数
游戏总次数：资源作品被玩家进入游玩累计次数
游戏总时长(分钟)：资源作品被玩家进入停留游玩的累计时长
游戏人数：资源作品被玩家进入游玩的累计人数
讨论数：资源作品详情页内的动态讨论数
收藏数：资源作品被玩家收藏的累计次数
点赞数：资源作品被玩家点赞的累计次数
广告总收入：玩家观看作品内的广告后产生的收益
广告曝光总次数：资源被点击播放广告的次数
贡献点数量：玩家使用迷你币消费您的作品所转换的分成
迷你豆数量：玩家使用迷你豆购买了作品所转换的分成
            </pre>
          </slot>
        </div>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.help-tooltip {
  .entry {
    display: flex;
    align-items: center;
    color: #8c8c8c;
    font-size: 14px;

    img {
      margin-left: 3px;
      width: 10px;
      height: 10px;
    }
    cursor: pointer;
  }
}
#tips-wrap {
  color: #fff;
  width: 400px;
  line-height: 1.8;
  height: 100%;
  .content-wrap {
    margin-bottom: 10px;
    .title {
      font-size: 14px;
    }
  }
}
.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: rgba(0, 0, 0, 0.6);
}
.el-tooltip__popper[x-placement^='bottom'] .popper__arrow:after {
  border-bottom-color: rgba(0, 0, 0, 0.6);
}
.atooltip {
  background: rgba(0, 0, 0, 0.6) !important;
}
</style>
